import logo from './logo.svg';
import './App.css';
import { BrowserRouter } from 'react-router-dom'
import Blog from './containers/Blog/Blog'

function App() {
  return (
      <Blog/>
  );
}

export default App;
